import { Component, createRef } from "react";
import { NSARouterMakerResult, NSABoxSecret } from "namirasoft-account-react";
import { AzureCreateRow, AzureRow } from "namirasoft-credential";
import { NSBox, NSBoxString, NSBoxTextArea, NSColumn } from "namirasoft-site-react";
import { CredentialEntities } from "../CredentialEntities";
import { CredentialLayout } from '../CredentialLayout';
import { CredentialProps } from "../CredentialProps";

interface AzureEditPageProps extends NSARouterMakerResult, CredentialProps
{
    isEdit: boolean;
}

export default class AzureEditPage extends Component<AzureEditPageProps>
{
    NSBoxString_Name = createRef<NSBoxString>();
    NSABoxSecret_TenantIDSecretID = createRef<NSABoxSecret>();
    NSABoxSecret_ClientIDSecretID = createRef<NSABoxSecret>();
    NSABoxSecret_ClientSecretSecretID = createRef<NSABoxSecret>();
    NSBoxTextArea_Description = createRef<NSBoxTextArea>();

    override render()
    {
        return (
            <CredentialLayout<AzureRow, AzureCreateRow>
                {...this.props}
                action={{
                    description: this.props.isEdit ? "This section allows you to edit a Microsoft Azure credential by updating its name, client id, client secret, tenant id, or description. The client secret is kept as a protected secret, and any application set up to use the credential applies the updated values." : "This section allows you to create a Microsoft Azure credential using a service principal by entering a name, a client id, a client secret, and a tenant id. Namirasoft encrypts the sensitive data for secure access, and any Namirasoft application you set up to use it can then authenticate to Azure."
                }}
                pages={{
                    entity: CredentialEntities.azure(this.props),
                    edit: {
                        ...this.props,
                        ui: {
                            tab_page_edit: {
                                editor: {
                                    getInputRow: (): AzureCreateRow =>
                                    {
                                        let name = this.NSBoxString_Name.current?.getValue() ?? "";
                                        let tenant_id = this.NSABoxSecret_TenantIDSecretID.current?.getValue() ?? "";
                                        let client_id = this.NSABoxSecret_ClientIDSecretID.current?.getValue() ?? "";
                                        let client_secret = this.NSABoxSecret_ClientSecretSecretID.current?.getValue() ?? "";
                                        let description = this.NSBoxTextArea_Description.current?.getValue() ?? "";

                                        return {
                                            workspace_id: "",
                                            name,
                                            tenant_id,
                                            client_id,
                                            client_secret,
                                            description,
                                            azure_category: [],
                                            azure_field: [],
                                            azure_tag: [],
                                        };
                                    },
                                    setRow: (row: AzureRow) =>
                                    {
                                        this.NSBoxString_Name.current?.setValue(row.name);
                                        this.NSABoxSecret_TenantIDSecretID.current?.setValue(row.tenant_id_secret_id);
                                        this.NSABoxSecret_ClientIDSecretID.current?.setValue(row.client_id_secret_id);
                                        this.NSABoxSecret_ClientSecretSecretID.current?.setValue(row.client_secret_secret_id);
                                        this.NSBoxTextArea_Description.current?.setValue(row.description);
                                    }
                                }
                            }
                        }
                    }
                }}
            >
                <NSColumn>
                    <NSBoxString
                        ref={this.NSBoxString_Name}
                        required
                        title="Name"
                        auto_complete="new-password"
                        info={{ link: "https://namirasoft.com/credential/console-guide/azure/#field-name" }}
                        style={{ width: NSBox.width.double }}
                    />
                                        <NSABoxSecret
                        ref={this.NSABoxSecret_TenantIDSecretID}
                        {...this.props}
                        required
                        title="Tenant ID"
                        auto_complete="new-password"
                        info={{ link: "https://namirasoft.com/credential/console-guide/azure/#field-tenant-id" }}
                        style={{ width: NSBox.width.double }}
                    />
                    <NSABoxSecret
                        ref={this.NSABoxSecret_ClientIDSecretID}
                        {...this.props}
                        required
                        title="Client ID"
                        auto_complete="new-password"
                        info={{ link: "https://namirasoft.com/credential/console-guide/azure/#field-client-id" }}
                        style={{ width: NSBox.width.double }}
                    />
                    <NSABoxSecret
                        ref={this.NSABoxSecret_ClientSecretSecretID}
                        {...this.props}
                        required
                        title="Client Password"
                        auto_complete="new-password"
                        info={{ link: "https://namirasoft.com/credential/console-guide/azure/#field-client-secret" }}
                        style={{ width: NSBox.width.double }}
                    />
                    <NSBoxTextArea
                        ref={this.NSBoxTextArea_Description}
                        required={false}
                        title="Description"
                        info={{ link: "https://namirasoft.com/credential/console-guide/azure/#field-description" }}
                        style={{ width: NSBox.width.double }}
                    />
                </NSColumn>
            </CredentialLayout >
        );
    }
}